import { useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"
import { useApi } from "../../../../hooks/useApi"
import { Order } from "../types/order"

const useReplaceOrderMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess: (order: Order) => void
  onError: (error: AxiosError) => void
}) => {
  const { scientApi } = useApi()

  return useMutation({
    mutationFn: ({ orderId, values }: { orderId: string; values: Partial<Order> }) =>
      scientApi.trading.replaceOrder(orderId, values),
    onSuccess,
    onError,
  })
}

export default useReplaceOrderMutation
